import { useState } from 'react';
import { motion } from 'framer-motion';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const portfolioItems = [
  {
    id: 1,
    title: 'Traditional Wood Living Room',
    category: 'Living Spaces',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/dbkzq0fl_Living_01.png',
    mood: 'Crafted Classic',
  },
  {
    id: 2,
    title: 'Heritage Carved Living Hall',
    category: 'Living Spaces',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/dg2lfl6d_Living_02.png',
    mood: 'Crafted Classic',
  },
  {
    id: 3,
    title: 'Modern U-Shape Kitchen',
    category: 'Kitchens',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/woq7sdsp_Kitchen_01.png',
    mood: 'Warm Contemporary',
  },
  {
    id: 4,
    title: 'Elegant Neutral Living Room',
    category: 'Living Spaces',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/p9o008he_Living_03.jpg',
    mood: 'Urban Luxe',
  },
  {
    id: 5,
    title: 'Fluted Panel Living Room',
    category: 'Living Spaces',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/tijae1yj_Living_04.png',
    mood: 'Warm Contemporary',
  },
  {
    id: 6,
    title: 'Classic Wooden Wardrobe',
    category: 'Wardrobes',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/oid76ebs_Wardrobe_01.png',
    mood: 'Crafted Classic',
  },
  {
    id: 7,
    title: 'Textured Wood Wardrobe',
    category: 'Wardrobes',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/6gt12bvs_Wardrobe_02.jpg',
    mood: 'Warm Contemporary',
  },
  {
    id: 8,
    title: 'Elegant Glossy Wardrobe',
    category: 'Wardrobes',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/2tanexoq_Wardrobe_03.png',
    mood: 'Urban Luxe',
  },
  {
    id: 9,
    title: 'Modern Glass Wardrobe',
    category: 'Wardrobes',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/apghenp6_Wardrobe_04.png',
    mood: 'Quiet Minimal',
  },
  {
    id: 10,
    title: 'Classic Wood Kitchen',
    category: 'Kitchens',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/xcsb8m2p_Kitchen_02.jpg',
    mood: 'Crafted Classic',
  },
  {
    id: 11,
    title: 'Minimal White Kitchen',
    category: 'Kitchens',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/u9irab38_Kitchen_03.jpg',
    mood: 'Quiet Minimal',
  },
  {
    id: 12,
    title: 'Natural Oak Kitchen',
    category: 'Kitchens',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/j5oe7dy9_Kitchen_05.jpg',
    mood: 'Natural Living',
  },
  {
    id: 13,
    title: 'Fluted Panel Master Bedroom',
    category: 'Bedrooms',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/40ps0rdg_Bedroom_01.png',
    mood: 'Urban Luxe',
  },
  {
    id: 14,
    title: 'Traditional Staircase Living',
    category: 'Living Spaces',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/tbce89tm_Living_05.png',
    mood: 'Crafted Classic',
  },
  {
    id: 15,
    title: 'Elegant Classic Bedroom',
    category: 'Bedrooms',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/2zhreovk_Bedroom_02.png',
    mood: 'Crafted Classic',
  },
  {
    id: 18,
    title: 'Luxury Tufted Bedroom',
    category: 'Bedrooms',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/5gth3ms0_Bedroom_03.png',
    mood: 'Urban Luxe',
  },
  {
    id: 19,
    title: 'Warm Wood Bedroom',
    category: 'Bedrooms',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/blxwv3ly_Bedroom_04.png',
    mood: 'Natural Living',
  },
  {
    id: 20,
    title: 'Tropical Theme Kids Bedroom',
    category: 'Bedrooms',
    image: 'https://customer-assets.emergentagent.com/job_design-intent/artifacts/rlpbt7gl_Bedroom_05.png',
    mood: 'Natural Living',
  },
];

const categories = ['All', 'Living Spaces', 'Kitchens', 'Bedrooms', 'Wardrobes'];

export default function PortfolioPage() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredItems = activeCategory === 'All' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeCategory);

  return (
    <div data-testid="portfolio-page" className="min-h-screen bg-[#F5F0E8]">
      <Header />
      
      <main className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {/* Page Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-16"
          >
            <span className="overline text-[#B5703A] block mb-4">Our Work</span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light text-[#2A2A2A] tracking-tight">
              Portfolio
            </h1>
            <p className="mt-6 text-[#3D3D3D] max-w-xl text-base">
              A curated selection of spaces we've crafted—each shaped by material, 
              proportion, and the unique way our clients live.
            </p>
          </motion.div>

          {/* Category Filter */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-wrap gap-3 mb-12"
          >
            {categories.map((category) => (
              <button
                key={category}
                data-testid={`filter-${category.toLowerCase().replace(' ', '-')}`}
                onClick={() => setActiveCategory(category)}
                className={`px-4 py-2 text-sm tracking-wide transition-colors duration-300 ${
                  activeCategory === category
                    ? 'bg-[#B5703A] text-white'
                    : 'bg-[#D9CFC0] text-[#2A2A2A] hover:bg-[#C4B6A4]'
                }`}
              >
                {category}
              </button>
            ))}
          </motion.div>

          {/* Portfolio Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredItems.map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="group"
              >
                <div className="image-hover-scale aspect-[4/3] bg-[#D9CFC0] mb-4">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="space-y-1">
                  <span className="overline text-[#B5703A] text-xs">{item.mood}</span>
                  <h3 className="text-xl font-light text-[#2A2A2A]">{item.title}</h3>
                  <p className="text-sm text-[#3D3D3D]">{item.category}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
